import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import AppTemplate from "./components/AppTemplate/AppTemplate";
import {useEffect, useState} from "react";
import * as actions from "./AppActions";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import "./App.scss";
import Modal from "react-modal";

import Users from "./pages/User/Users";
import Login from "./pages/Login/Login";
import Forms from "./pages/Form/Forms";
import Clients from "./pages/client/Clients";
import CreateForm from "./pages/createForm/CreateForm/CreateForm";
import ProtectedRoute from "./ProtectedRoute";
import Customers from "./pages/Customer/Customers";
import EditCustomer from "./pages/Customer/EditCustomer";
import Client from "./pages/client/Client";
import UserProfile from "./pages/User/UserProfile";
import Settings from "./pages/Settings/Settings";
import EditSettings from "./pages/Settings/EditSettings";
import Public from "./pages/Public/Public/Public";
import SentEmails from "./pages/SentEmails/SentEmails";
import SentEmailDetail from "./pages/SentEmails/SentEmailDetail";
import PublicForm from "./pages/Public/PublicForm/PublicForm";
import AppLayout from "./components/AppLayout/AppLayout";
import AxiosSetup from "./api/AxiosSetup";
import appConfig from "./config/applicationConfiguration";
import {NotificationProvider} from "./hooks/useNotification";
import Documents from "./pages/Document/Documents";
import Document from "./pages/Document/Document";
import UserProvider from "./contexts/userContext/UserContext";

Modal.setAppElement("#root");

const App = () => {
    const [backendVersion, setBackendVersion] = useState(null);

    useEffect(() => {
        actions.getBackendHealth(setBackendVersion);
    }, []);

    return (
        <div className="app">
            <GoogleReCaptchaProvider reCaptchaKey={appConfig.recaptchaSiteKey}>
                <AppTemplate backendVersion={backendVersion}>
                    <Router>
                        <UserProvider>
                            <NotificationProvider>
                                <AxiosSetup/>
                                <Routes>
                                    <Route element={<ProtectedRoute/>}>
                                        <Route element={<AppLayout/>}>
                                            <Route path="/users" element={<Users/>}/>
                                            <Route path="/users/profile" element={<UserProfile/>}/>

                                            <Route path="/forms" element={<Forms/>}/>
                                            <Route path="/forms/create_form/:id" element={<CreateForm/>}/>

                                            <Route path="/clients" element={<Clients/>}/>
                                            <Route path="/clients/client/:id?" element={<Client/>}/>

                                            <Route path="/customers" element={<Customers/>}/>
                                            <Route path="/customers/customer/:id?" element={<EditCustomer/>}/>

                                            <Route path="/settings" element={<Settings/>}/>
                                            <Route path="/settings/:id" element={<EditSettings/>}/>

                                            <Route path="/sent-emails" element={<SentEmails/>}/>
                                            <Route path="/sent-emails/:id" element={<SentEmailDetail/>}/>

                                            <Route path="/documents" element={<Documents/>}/>
                                            <Route path="/documents/document/:id" element={<Document/>}/>
                                        </Route>
                                    </Route>

                                    <Route path="/" element={<Login/>}/>
                                    <Route path="/:id" element={<Public/>}/>
                                    <Route path="/form/:publicId" element={<PublicForm/>}/>
                                </Routes>
                            </NotificationProvider>
                        </UserProvider>
                    </Router>
                </AppTemplate>
            </GoogleReCaptchaProvider>
        </div>
    );
};

export default App;